import gql from "graphql-tag";

export default gql`
  query GetCompanyWorkOrders($id: ID!) {
    allWorkOrders(filter: { company: { id: $id } }) {
      id
      createdAt
      title
      description
      dueDate
      time
      startDate
      endDate
      interval
      isRecurring
      recurrence
      recurrenceDates
      estimatedDuration
      priority
      status
      assignedTo {
        id
        firstName
        lastName
        email
      }
      additionalWorkers {
        id
        firstName
        lastName
        email
      }
      site {
        id
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Queries/GetCompanyWorkOrders.ts